<template>
	<el-form size="mini" ref="form" :model="form" label-width="100px" :inline="true">
		<el-form-item label="序列号" style="display: block;width: 1000px !important;" class="detail_item">
			<el-input style="width: 776px !important;" readonly v-model="item.number"></el-input>
		</el-form-item>

		<el-form-item label="发票号" class="detail_item">
			<el-input readonly v-model="form.invoicecode"></el-input>
		</el-form-item>
		<el-form-item label="开票时间" class="detail_item">
			<el-input readonly v-model="form.invoicetime"></el-input>
		</el-form-item>
		<!-- 		<el-form-item label="发票产品品名" class="detail_item">
			<el-input readonly v-model="form.invoicetype"></el-input>
		</el-form-item> -->
		<el-form-item label="发票规格" class="detail_item">
			<el-input readonly v-model="form.invoiceclass"></el-input>
		</el-form-item>
		<el-form-item label="单位" class="detail_item">
			<el-input readonly v-model="form.invoiceunit"></el-input>
		</el-form-item>
		<el-form-item label="预开票金额" class="detail_item">
			<el-input readonly v-model="form.invoicepreamount"></el-input>
		</el-form-item>
		<el-form-item label="开票数量" class="detail_item">
			<el-input readonly v-model="form.invoicenum"></el-input>
		</el-form-item>
		<el-form-item label="开票单价" class="detail_item">
			<el-input readonly v-model="form.invoiceprice"></el-input>
		</el-form-item>
		<el-form-item label="开票金额" class="detail_item">
			<el-input readonly v-model="form.invoiceamount"></el-input>
		</el-form-item>
		<!-- 		<el-form-item label="开票税率" class="detail_item">
			<el-input readonly v-model="form.invoicetaxratio"></el-input>
		</el-form-item> -->
		<el-form-item label="开票税额" class="detail_item">
			<el-input readonly v-model="form.invoicetax"></el-input>
		</el-form-item>
		<el-form-item style="width: 100%;margin-left: 100px;" v-if="false">
			<el-button type="primary" @click="onSubmit">保存</el-button>
		</el-form-item>
	</el-form>
</template>
<style scoped>
	.detail_item {
		margin-bottom: 4px;
	}
</style>
<script>
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				form: {
					invoicecode: '',
					invoicetime: '',
					invoicetype: '',
					invoiceclass: '',
					invoiceunit: '',
					invoicenum: '',
					invoiceprice: '',
					invoiceamount: '',
					invoicetaxratio: '',
					invoicetax: '',
					invoicepreamount:''
				}

			}
		},
		watch: {

		},
		computed: {

		},
		created() {
			for (let i in this.form) {
				this.form[i] = this.item[i]

			}
		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.log('submit!');
			}
		},
		components: {

		}
	}
</script>
